(function(window, $) {
  'use strict';

  if (!$) {
    return;
  }

  var countdownLayout = '<span>{dn}</span> D - <span>{hn}</span> H - <span>{mn}</span> M - <span>{sn}</span> S';

  function initCountdowns() {
    if (!$.fn.countdown) {
      return;
    }

    $('.bc-countdown').each(function() {
      var $countdown = $(this);
      var year = parseInt($countdown.attr('data-countdown-year'), 10);
      var month = parseInt($countdown.attr('data-countdown-month'), 10);
      var day = parseInt($countdown.attr('data-countdown-day'), 10);
      var dueDate;

      if ($countdown.data('countdown-initialized') || isNaN(year) || isNaN(month) || isNaN(day)) {
        return;
      }

      $countdown.data('countdown-initialized', true);
      dueDate = new Date(year, month - 1, day);

      if (new Date() < dueDate) {
        $countdown.countdown({
          until: dueDate,
          layout: countdownLayout
        });
      } else {
        $countdown.parent().hide();
      }
    });
  }

  $(initCountdowns);
}(window, window.jQuery));
